
import React from 'react';

const GameFeatures = () => {
  const features = [
    {
      title: "Collect & Evolve",
      description: "Catch over 150 Pokemon from the original generation and evolve them into more powerful forms",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M2 12h20" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      )
    },
    {
      title: "Strategic Upgrades",
      description: "Invest in upgrades that increase your clicking power, catch rate, and automatic Pokemon generation",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
        </svg>
      )
    },
    {
      title: "Gym Battles",
      description: "Challenge Pokemon gym leaders with your team and earn special badges and rewards",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-yellow-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 15l-8.5 8.5 1.5-7-6-4h7l3-8 3 8h7l-6 4 1.5 7z" />
        </svg>
      )
    },
    {
      title: "Complete Pokedex",
      description: "Fill your Pokedex with all available Pokemon to unlock special achievements and bonuses",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M3 9h18M9 3v18" />
        </svg>
      )
    },
    {
      title: "Special Events",
      description: "Participate in limited-time events to catch legendary Pokemon and earn exclusive rewards",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-purple-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L7 7H3v4l-3 3 3 3v4h4l5 5 5-5h4v-4l3-3-3-3V7h-4l-5-5z" />
        </svg>
      )
    },
    {
      title: "Cross-Platform",
      description: "Play on any device with a web browser - your progress saves automatically to continue anywhere",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-indigo-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8m-4-4v4" />
        </svg>
      )
    }
  ];

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-lg shadow-xl overflow-hidden">
        <div className="p-6 sm:p-10">
          <h2 className="text-3xl font-bold text-center text-white mb-12">
            Key Features of Pokemon Clicker 2
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg transform transition duration-300 hover:scale-105"
              >
                <div className="flex justify-center mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-center text-gray-900 dark:text-white mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-700 dark:text-gray-300 text-center">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center">
            <p className="text-lg text-white">
              Experience the exciting world of Pokemon Clicker 2 - completely free to play online!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GameFeatures;
